import * as React from 'react';

import { Checkbox, } from '../../../../Shared'
import DemoGuardedButton from '../../shared/demoGuardedButton';

export interface CheckboxSettingsGroup {
  attribute: string
  checkboxId?: string
  checkboxLabel: string
  description: React.ReactNode
  heading?: string
  note?: string
}

interface CheckboxSettingsSectionProps {
  activateSection: () => void
  active: boolean
  deactivateSection: () => void
  groups: CheckboxSettingsGroup[]
  passedValues: Record<string, boolean>
  sectionClassName: string
  sectionId: string
  title: string
  updateTeacherInfo: (data: Record<string, boolean>, copy: string) => void
}

const CheckboxSettingsSection = ({ activateSection, active, deactivateSection, groups, passedValues, sectionClassName, sectionId, title, updateTeacherInfo, }: CheckboxSettingsSectionProps) => {
  const [values, setValues] = React.useState(passedValues)

  React.useEffect(() => {
    if (active) { return }

    reset()
  }, [active])

  function reset() {
    setValues(passedValues)
  }

  function toggle(attribute: string) {
    activateSection()
    setValues({ ...values, [attribute]: !values[attribute], })
  }

  function resetAndDeactivateSection() {
    reset()
    deactivateSection()
  }

  function handleSubmit(e) {
    e?.preventDefault()
    updateTeacherInfo(values, 'Settings saved')
  }

  function renderButtonSection() {
    if (!active) { return }

    const submitButtonClassName = "quill-button contained medium green focus-on-light"
    const changed = groups.some(({ attribute, }) => values[attribute] !== passedValues[attribute])

    let submitButton = <input aria-label="Save changes" className={`${submitButtonClassName} disabled`} disabled type="submit" value="Save changes" />

    if (changed) {
      submitButton = <DemoGuardedButton className={submitButtonClassName} onClick={handleSubmit}>Save changes</DemoGuardedButton>
    }

    return (
      <div className="button-section">
        <button className="quill-button outlined medium grey focus-on-light" id="cancel" onClick={resetAndDeactivateSection} type="button">Cancel</button>
        {submitButton}
      </div>
    )
  }

  function renderGroup({ attribute, checkboxId, checkboxLabel, description, heading, note, }: CheckboxSettingsGroup) {
    function handleClick() { toggle(attribute) }

    return (
      <div className="settings-group" key={attribute}>
        {heading && <h2 className="settings-group-heading">{heading}</h2>}
        <p className={`${sectionClassName}-description`}>{description}</p>
        <div className="fields">
          <Checkbox
            id={checkboxId}
            label={checkboxLabel}
            onClick={handleClick}
            selected={values[attribute]}
          />
        </div>
        {note && <p className="settings-group-note">{note}</p>}
      </div>
    )
  }

  return (
    <section aria-labelledby={sectionId} className={`user-account-section ${sectionClassName}`}>
      <h1 id={sectionId}>{title}</h1>
      <form acceptCharset="UTF-8" onSubmit={handleSubmit} >
        {groups.map(renderGroup)}
      </form>
      {renderButtonSection()}
    </section>
  )
}

export default CheckboxSettingsSection
